import React from "react";
import { connect } from "react-redux";
import { updateUserAttributes } from "aws-amplify/auth";
import { withStyles } from "@material-ui/core/styles";
import { I18n } from "@aws-amplify/core";

import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import InputLabel from "@material-ui/core/InputLabel";
import Box from "@material-ui/core/Box";

import CustomButton from "../Common/CustomButton";

import { updateUser } from "../../actions/user";

import colors from "../../assets/style/colors";

const styles = {
  inputLabel: {
    color: colors.black87,
    fontWeight: "500",
    marginTop: "24px",
    fontSize: "1em"
  },
  centerButton: {
    textAlign: "center"
  },
  input: {
    height: "40px"
  },
  updateMessage: {
    textAlign: "center",
    color: colors.primary,
    fontWeight: "500",
    marginTop: "100px"
  }
};

class PersonalInfo extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      firstName: "",
      lastName: "",
      email: "",
      userInfoSet: false
    };
  }

  componentDidMount() {
    if (this.props.user.firstName !== undefined) {
      this.getUserInfo();
    }
  }

  componentDidUpdate() {
    if (!this.state.userInfoSet) {
      this.getUserInfo();
    }
  }

  getUserInfo() {
    this.setState({
      firstName: this.props.user.firstName,
      lastName: this.props.user.lastName,
      email: this.props.user.email,
      userInfoSet: true
    });
  }

  handleInputChange = event => {
    this.setState({
      [event.target.id]: event.target.value
    });
  };

  submit = async (event) => {
    event.preventDefault();
    try {
      const result = await updateUserAttributes({
        userAttributes: {
          name: this.state.firstName,
          family_name: this.state.lastName,
          email: this.state.email,
        },
      });
      console.log(result);

      this.props.dispatch(
        updateUser({
          name: this.state.firstName,
          familyName: this.state.lastName,
          email: this.state.email,
        })
      );
      this.setState({ updateStatus: "success" });
    } catch (err) {
      console.log(err);
      this.setState({ updateStatus: "fail" });
    }
  };

  render() {
    return (
      <>
        <Grid item xs>
          <form>
            <InputLabel
              htmlFor="name"
              className={this.props.classes.inputLabel}
            >
              {I18n.get("account_firstName")}
            </InputLabel>
            <TextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              id="name"
              name="name"
              value={this.state.firstName}
              onChange={this.handleInputChange}
              InputProps={{
                classes: { root: this.props.classes.input }
              }}
            />
            <InputLabel
              htmlFor="familyName"
              className={this.props.classes.inputLabel}
            >
              {I18n.get("account_lastName")}
            </InputLabel>
            <TextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              id="familyName"
              name="familyName"
              value={this.state.lastName}
              onChange={this.handleInputChange}
              InputProps={{
                classes: { root: this.props.classes.input }
              }}
            />
            <InputLabel
              htmlFor="email"
              className={this.props.classes.inputLabel}
            >
              {I18n.get("account_emailAddress")}
            </InputLabel>
            <TextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              autoComplete="email"
              id="email"
              name="email"
              value={this.state.email}
              disabled={true}
              onChange={this.handleInputChange}
              InputProps={{
                classes: { root: this.props.classes.input }
              }}
            />
            <Box className={this.props.classes.updateMessage}>
              {this.state.updateStatus === "success" &&
                I18n.get("account_updateSuccessful")}
            </Box>
          </form>
        </Grid>
        <Grid item>
          <Box className={this.props.classes.centerButton}>
            <CustomButton
              onClick={this.submit}
              variant="contained"
              color="primary"
            >
              {I18n.get("account_update")}
            </CustomButton>
          </Box>
        </Grid>
      </>
    );
  }
}

const mapStateToProps = state => {
  if (state.user) {
    return {
      user: state.user
    };
  }
  return {
    user: {}
  };
};

export default connect(mapStateToProps)(withStyles(styles)(PersonalInfo));
